export default __webpack_public_path__ + "static/media/contact-banner.f7d46309.png";